<template>
    <div class="row">

        <div class="col-3 position-fixed bg-light d-flex flex-column  min-vh-100" style="margin-top: -40px; padding-top: 40px;">

            <b-tabs content-class="mt-3">
                <b-tab title="Liste" active>
                    <h4>Contact lists</h4>
                    <div class="mt-1 mb-1">
                        Selecteaza
                        <a @click="checkAll" class="text-primary">toate</a> |
                        <a @click="uncheckAll" class="text-primary">nimic</a>
                    </div>
                    <ContactList
                            v-for="list in contactLists"
                            :key="list.id"
                            :name="list.name"
                            :id="list.id"
                            ref="contactLists"
                            @click="search"
                    />
                </b-tab>
                <b-tab title="Parametri">
                    <p>Selecteaza contacte ce vor fi notificate in functie de parametrii unui anumit cutremur.</p>
                    <form class="compact" @submit.prevent="getLists">
                        <div class="form-group row">
                            <label for="magnitude" class="col-5 col-form-label-sm">Magnitudine</label>
                            <div class="col-7">
                                <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        id="magnitude"
                                        v-model="listSelector.magnitude"
                                >
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="depth" class="col-5 col-form-label-sm">Adancime(km)</label>
                            <div class="col-7">
                                <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        id="depth"
                                        v-model="listSelector.depth"
                                >
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="quake-type" class="col-5 col-form-label-sm">Tip cutremur</label>
                            <div class="col-7">
                                <select
                                        id="quake-type"
                                        class="form-control form-control-sm"
                                        v-model="listSelector.quakeType"
                                >
                                    <option selected>Selecteaza</option>
                                    <option>EWS</option>
                                    <option>LOCAL</option>
                                    <option>REGIONAL</option>
                                    <option>NONLOCAL_SEA</option>
                                    <option>NONLOCAL_LAND</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12">
                                <button class="btn btn-primary btn-block">Selecteaza liste</button>
                            </div>
                        </div>
                    </form>
                    <div class="row mt-3" v-if="selectedLists.length > 0">
                        <div class="col-12">
                            <div class="alert alert-info mb-0">
                                <p style="font-weight: bolder; border-bottom: 1px solid" class="mb-1 border-info">
                                    Liste selectate automat
                                </p>
                                <p>
                                    <span
                                            class="list-name badge badge-success mr-1"
                                            v-for="list in selectedLists"
                                    >
                                        {{list.name}}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
            <div class="mt-3">
                <div class="alert alert-warning text-center" v-if="action != 'idle'">
                    <p v-if="action == 'loading'" class="mb-0">
                        Se descarca date ...
                    </p>
                    <p v-if="action == 'compiling'" class="mb-0">
                        Compilam statistici ...
                    </p>
                </div>
                <div class="row" v-if="stats">
                    <div class="col">
                        <div class="alert alert-info">
                            <p style="font-weight: bolder; border-bottom: 1px solid" class="mb-1 border-info">
                                Selectia contine
                            </p>
                            <table class="w-100">
                                <tbody>
                                    <tr>
                                        <td>Persoane</td>
                                        <td>{{stats.persons}}</td>
                                    </tr>
                                    <tr>
                                        <td>Numere de telefon</td>
                                        <td>{{stats.phones}}</td>
                                    </tr>
                                    <tr>
                                        <td>Adrese de email</td>
                                        <td>{{stats.emails}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-9 offset-3">
            <h4>Subscriberi notificari SMS/Email</h4>
            <form @submit.prevent="search">
                <div class="form-group">
                    <input
                            type="text"
                            class="form-control"
                            id="search"
                            placeholder="Se pot face cautari dupa nume, organizatie, comentariu, numar de telefon sau adresa de email"
                            @input="updateSearchWord"
                    >
                </div>
            </form>
            <div class="row mb-3">
                <div class="col-12 d-flex flex-row">
                    <b-button v-if="hasRole('admin')" variant="secondary" @click="addPerson" class="btn-sm">Adauga persoana</b-button>
                    <form class="ml-auto compact form-inline d-inline-block">
                        <div class="form-group">
                            <label for="sort-by" class="col-form-label-sm mr-3">Sorteaza dupa</label>
                            <select id="sort-by" class="form-control form-control-sm">
                                <option selected>Selecteaza</option>
                                <option>Nume</option>
                                <option>Organizatie</option>
                                <option>Data actualizare</option>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
            <Person
                    v-for="(person,index) in persons"
                    :key="person.id"
                    :id="person.id"
                    :index="index"
                    :name="person.name"
                    :updated_at="person.updated_at"
                    :organization="person.organization"
                    :comment="person.comment"
                    :contacts="person.contacts"
                    @deletePerson="deletePerson(person.id)"
                    @editPerson="editPerson(person.id)"
                    ref="persons"
            />
        </div>
        <EditablePerson
            :index="selectedPerson.index"
            :name="selectedPerson.name"
            :organization="selectedPerson.organization"
            :comment="selectedPerson.comment"
            :id="selectedPerson.id"
            :contacts="selectedPerson.contacts"
            ref="editForm"
        />
    </div>
</template>

<script>
    import * as types from '../store/types.js'
    import Person from '../components/Person.vue'
    import ContactList from '../components/ContactList'
    import { mapState, mapGetters, mapActions } from 'vuex'

    import EditablePerson from '../components/EditablePerson'

    export default {
        components: {
            Person,
            EditablePerson,
            ContactList
        },
        data: () => {
            return {
                selectedPerson: {
                    contacts: []
                },
                listSelector: {
                    magnitude: null,
                    depth: null,
                    quakeType: null
                }
            }
        },
        methods: {
            ...mapActions('search', [types.SEARCH_CHECK_LISTS, types.SEARCH_UNCHECK_ALL_LISTS]),
            getLists(e){
                this.$store.dispatch('contactLists/'+types.CONTACT_LISTS_GET_BY_PARAMS, this.listSelector)
                    .then(lists => {
                        this.$store.dispatch('search/'+types.SEARCH_SET_PARAMETERS, {
                            ...this.searchParameters,
                            ... {
                                lists: lists
                            }
                        }).then(() => {
                            console.log('doing search')
                            this.search().then(() => {
                                console.log('search complete')
                            })
                        })
                    })
            },
            async checkAll(){
                this[types.SEARCH_CHECK_LISTS](
                    this.$refs.contactLists.map(list => list.$props.id)
                )
                await this.search()
            },
            async uncheckAll(){
                this[types.SEARCH_UNCHECK_ALL_LISTS]()
                await this.search()
            },
            handleDeleteOK(person){
                console.log('delete confirmed')
            },
            async onPersonDelete(person){
                this.selectedPerson = person
                const response = await this.$bvModal.msgBoxConfirm(
                    'Sigur vrei sa il stergi pe '+ this.selectedPerson.name + '?',
                    {
                        title: 'Confirmi stergerea?',
                        // size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Sterge',
                        cancelTitle: 'Anuleaza',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    }
                )
                if(response === true){
                    await this.$store.dispatch('persons/'+types.PERSONS_DELETE, person)
                }
            },
            addPerson(){
                this.selectedPerson = {
                    contacts: []
                }
                this.$refs['editForm'].show(this.selectedPerson)
            },
            editPerson(personId){
                // this.selectedPerson = {...this.$refs.persons[personIndex].$props}
                this.$refs['editForm'].show(personId)
            },
            deletePerson(personId){
                this.$store.dispatch('persons/'+types.PERSONS_DELETE,personId).then(() => {
                    console.log('person deleted')
                })
            },
            async updateSearchWord(e){
                await this.$store.dispatch('search/'+types.SEARCH_SET_PARAMETERS, {
                    ...this.searchParameters,
                    ... {
                        search: e.target.value
                    }
                })
                await this.search()
            },
            async search(){
                // await this.$store.dispatch('search/'+types.SEARCH_SET_PARAMETERS, this.searchParams.search)
                // await this.$store.dispatch('persons/'+types.PERSONS_SEARCH_UPDATE, this.searchParams.search)
                console.log(this.searchParameters)
                // if(this.searchParameters.search && this.searchParameters.search.length >= 3){
                await this.$store.dispatch('persons/'+types.PERSONS_FETCH, this.searchParameters)
                // }
            },

        },
        beforeMount(){
            this.$store.dispatch('contactLists/'+types.CONTACT_LISTS_REQUEST)
            this.$store.dispatch('persons/'+types.PERSONS_FETCH)
        },
        computed: {
            selectedLists(){
                return this.contactLists.filter(list => this.searchParameters.lists.indexOf(list.id) !== -1)
            },
            ... mapState('contactLists', ['contactLists']),
            ... mapState('persons', ['persons', 'stats']),
            ... mapGetters('persons', ['action']),
            ... mapGetters('auth', ['hasRole']),
            ... mapState('search', {
                searchParameters: 'parameters'
            })
        }
    }
</script>

<style scoped>

</style>